import types from '../types';
import { duckConstants } from '../../../constants';
import { extractState } from '../../../utilities/combineUseReducer';

const reducer = (state, action) => {
  switch (action.type) {
    /* CREATE LCI */
    case types.CREATE_LCI: {
      return { ...state, creatingLCI: true, startLCISuccess: false, startLCIError: false };
    }

    case types.CREATE_LCI_SUCCESS: {
      const submitMessage = { type: 'success' };
      return { ...state, creatingLCI: false, submitMessage };
    }

    case types.CREATE_LCI_ERROR: {
      const submitMessage = { type: 'error' };
      return { ...state, creatingLCI: false, submitMessage };
    }

    case types.EDIT_LCI: {
      return { ...state, updatingLCI: false, submitMessage: null };
    }

    case types.UPDATE_LCI: {
      return { ...state, updatingLCI: true, submitMessage: null };
    }

    case types.UPDATE_LCI_SUCCESS: {
      const submitMessage = { type: 'success' };
      return { ...state, updatingLCI: false, submitMessage };
    }

    case types.UPDATE_LCI_ERROR: {
      const submitMessage = { type: 'error' };
      return { ...state, updatingLCI: false, submitMessage };
    }

    /** SEND LCI ACCESS CODE */
    case types.SEND_LCI_ACCESS_CODE: {
      return { ...state, sendingAccessCode: true, sendMessage: null };
    }

    case types.SEND_LCI_ACCESS_CODE_SUCCESS: {
      const sendMessage = { type: 'success' };
      return { ...state, sendingAccessCode: false, sendMessage };
    }

    case types.SEND_LCI_ACCESS_CODE_ERROR: {
      const sendMessage = { type: 'error' };
      return { ...state, sendingAccessCode: false, sendMessage };
    }

    case types.RESET_ACCESS_CODE_SEND_MESSAGE: {
      return { ...state, sendMessage: null };
    }

    /* START LCI */
    case types.START_LCI: {
      return { ...state, start_lc_id: action.lc_id, startingLCI: true, startLCISuccess: false, startLCIError: false };
    }

    case types.START_LCI_SUCCESS: {
      return { ...state, startingLCI: false, startLCISuccess: true, startLCIError: false };
    }

    case types.START_LCI_ERROR: {
      return { ...state, startingLCI: false, startLCISuccess: false, startLCIError: true };
    }

    case types.CANCEL_LCI: {
      return { ...state, cancellationLCI: true, cancelLCISuccess: false, cancelLCIError: false };
    }

    case types.CANCEL_LCI_ERROR: {
      return { ...state, cancellationLCI: false, cancelLCISuccess: false, cancelLCIError: true };
    }

    case types.CANCEL_LCI_SUCCESS: {
      return { ...state, cancellationLCI: false, cancelLCISuccess: true, cancelLCIError: false };
    }

    /* EXTRA */
    case types.CLEAR_START_LCI_FLAG:
    case types.CLEAR_SUCCESS_ERROR_FLAGS: {
      return { ...state, startingLCI: false, startLCISuccess: false, startLCIError: false, sendingAccessCode: false, sendMessage: null };
    }

    case types.RESET_DATA: {
      return { };
    }

    case types.REHYDRATE: {
      /* INITIAL STATE */
      const initialState = (state && state[stateKey]) ? { ...state[stateKey] } : extractState(duckConstants.LCI_SETUP_ROOT, stateKey);
      return { ...state, ...initialState };
    }

    default:
      return state;
  }
};

const stateKey = 'lciCRUD';

export default { reducer, stateKey };
